import { createReducer, on } from '@ngrx/store';
import { CompanyContactsActions } from './company-contacts.actions';
import { CompanyContact } from '@src/app/core/types/company-contact.type';

export interface CompanyContactsState {
  contacts: CompanyContact[];
  loading: boolean;
  error: any;
}

export const initialState: CompanyContactsState = {
  contacts: [],
  loading: false,
  error: null,
};

export const companyContactsReducer = createReducer(
  initialState,
  on(CompanyContactsActions.loadCompanyContacts, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(
    CompanyContactsActions.loadCompanyContactsSuccess,
    (state, { contacts }) => {
      return {
        ...state,
        contacts,
        loading: false,
      };
    },
  ),
  on(CompanyContactsActions.loadCompanyContactsFailure, (state, { error }) => {
    console.error(
      '❌ Reducer: loadCompanyContactsFailure action received',
      error,
    );
    return {
      ...state,
      loading: false,
      error,
    };
  }),
  on(CompanyContactsActions.addCompanyContactSuccess, (state, { contact }) => ({
    ...state,
    contacts: [...state.contacts, contact],
  })),
  on(CompanyContactsActions.updateCompanyContact, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    CompanyContactsActions.updateCompanyContactSuccess,
    (state, { contact }) => ({
      ...state,
      contacts: state.contacts.map((c) => (c.id === contact.id ? contact : c)),
      loading: false,
    }),
  ),
  on(
    CompanyContactsActions.updateCompanyContactFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),
  ),
  on(CompanyContactsActions.updateContactProfiles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    CompanyContactsActions.updateContactProfilesFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),
  ),
  on(CompanyContactsActions.deleteCompanyContact, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    CompanyContactsActions.deleteCompanyContactSuccess,
    (state, { contactId }) => ({
      ...state,
      contacts: state.contacts.filter((c) => c.id !== contactId),
      loading: false,
    }),
  ),
  on(
    CompanyContactsActions.deleteCompanyContactFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),
  ),
);
